import {NgOptimizedImage} from '@angular/common';
import {ChangeDetectionStrategy, Component, inject, Input} from '@angular/core';
import {MatCard, MatCardContent} from '@angular/material/card';
import {Store} from '@ngrx/store';
import {FilledButtonComponent} from '@aviary/buttons/filled-button/filled-button.component';
import {DetailFieldComponent} from '@aviary/components/detail-field/detail-field.component';
import {buildFormGroup, getExtendedControlFrom} from '@aviary/forms/form.helpers';
import {ExtendedFormControl} from '@aviary/forms/extensions/extended-form-control/extended-form-control';
import {ExtendedFormGroup} from '@aviary/forms/extensions/extended-form-group/extended-form-group';
import {CheckboxFormFieldComponent} from '@aviary/forms/fields/checkbox-form-field/checkbox-form-field.component';
import {SelectFormFieldComponent} from '@aviary/forms/fields/select-form-field/select-form-field.component';
import {SelectPipe} from '@aviary/pipes/select.pipe';
import {snapshot} from '@aviary/store/store.helpers';
import {ConfirmedPasswordFormFieldComponent} from '@lib/components/confirmed-password-form-field/confirmed-password-form-field.component';
import {BranchSelectors} from '@store/branches/branch.selectors';
import {PatronSelectors} from '@store/patron/patron.selectors';
import {RegistrationActions} from '@store/registration/registration.actions';
import {FALLBACK_CREATE_PASSWORD_VALUE} from '@store/registration/registration.fallback';
import {RegistrationSelectors} from '@store/registration/registration.selectors';
import {RegistrationValidators} from '@store/registration/registration.validators';
import {FormatPipe} from '@aviary/pipes/format.pipe';
import {ViewportSelectors} from '@aviary/store/viewport/viewport.selectors';
import {LinkButtonComponent} from '@aviary/buttons/link-button/link-button.component';

@Component({
  selector: 'px-registration-create-password-form',
  host: {
    class: 'flex flex-col-reverse gap-x-4 gap-y-6 md:flex-row lg:justify-between'
  },
  templateUrl: './registration-create-password-form.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CheckboxFormFieldComponent, ConfirmedPasswordFormFieldComponent, DetailFieldComponent, FilledButtonComponent, FormatPipe, MatCard, MatCardContent,
    NgOptimizedImage, SelectFormFieldComponent, SelectPipe, LinkButtonComponent
  ]
})
export class RegistrationCreatePasswordFormComponent {
  @Input() forLookupContext = false;

  @Input() set pickupBranchId(pickupBranchId: number) {
    this.pickupBranchIdFieldControl.patchValue(pickupBranchId);
  }

  private readonly store = inject(Store);
  public readonly registrationSelectors = RegistrationSelectors.Registration;
  public readonly viewportSelectors = ViewportSelectors;
  public readonly patronSelectors = PatronSelectors.Auth;
  public readonly branchSelectors = BranchSelectors.PickupLocations;
  public readonly createPasswordForm: ExtendedFormGroup = buildFormGroup({
    ...FALLBACK_CREATE_PASSWORD_VALUE,
    branchId: snapshot(this.registrationSelectors.branchId)
  }, inject(RegistrationValidators).createPassword);
  private readonly pickupBranchIdFieldControl: ExtendedFormControl = getExtendedControlFrom(this.createPasswordForm, 'branchId');

  public onClickNext(): void {
    this.store.dispatch(RegistrationActions.updateRegistration(this.createPasswordForm.value));
    this.store.dispatch(this.forLookupContext ? RegistrationActions.registerExisting() : RegistrationActions.register());
  }

  public onClickCardPolicy(): void {
    this.store.dispatch(RegistrationActions.showLibraryCardPolicyDialog());
  }
}
